<script lang="ts">
/**
 * Teal gradient callout (`.hb` in `StudyPresentationShell`): bordered panel with body copy.
 * `bodyHtml` is rendered inside `<p>` with `{@html}` — trusted study copy only.
 */
interface Props {
  bodyHtml: string
  cardClass?: string
  cardStyle?: string
  paragraphStyle?: string
}

let { bodyHtml, cardClass = '', cardStyle, paragraphStyle }: Props = $props()
</script>

<div class="hb {cardClass}" style={cardStyle}>
  <p style={paragraphStyle}>{@html bodyHtml}</p>
</div>
